import { isValidCuil } from '../functions/validations'

const validCharactersSpecial = /^[a-zA-Z\dñ\s]+$/

const settingValidateCompany = {
  cuit: {
    required: 'Campo requerido',
    validate: (value: string) => {
      const cuit = value.replace(/-/gi, '')
      return isValidCuil(cuit) || 'Dato no válido'
    },
  },
  businessName: {
    required: 'Campo requerido',
    maxLength: {
      value: 40,
      message: 'Ingresá un máximo de 40 caracteres',
    },
  },
  postalCode: {
    required: 'Campo requerido',
    pattern: {
      value: /[0-9][0-9][0-9][0-9]/,
      message: 'Ingresá un código postal de cuatro dígitos',
    },
  },
  street: {
    required: 'Campo requerido',
    pattern: {
      value: /^(?=.*[A-Za-zÁÉÍÓÚáéíóúñÑ])(?=.*\d).+$/,
      message: 'Debe contener texto y al menos un número',
    },
  },
  floor: {
    pattern: {
      value: /^[1-9]+/,
      message: 'Dato no válido',
    },
  },
  dept: {
    required: false,
    pattern: {
      value: validCharactersSpecial,
      message: 'Dato no válido',
    },
  },
  provinceId: {
    required: 'Campo requerido',
  },
  locality: {
    required: 'Campo requerido',
    pattern: {
      value: validCharactersSpecial,
      message: 'Dato no válido',
    },
  },
  ivaId: {
    required: 'Campo requerido',
  },
  categoryIibbId: {
    required: 'Campo requerido',
  },
  categoryIibbIdcategoryIibbIIBB1: {
    required: 'Campo requerido',
    minLength: {
      value: 9,
      message: 'Dato no válido',
    },
  },
  categoryIibbIdcategoryIibbIIBB1BSAS: {
    required: 'Campo requerido',
    minLength: {
      value: 11,
      message: 'Dato no válido',
    },
  },
  categoryIibbIdcategoryIibbIIBB2: {
    required: 'Campo requerido',
    minLength: {
      value: 14,
      message: 'Dato no válido',
    },
  },
}
export default settingValidateCompany
